import { Analytics } from '@vercel/analytics/react';
import App from './App';
import LegalPage from './components/LegalPage';
import NotFoundPage from './components/NotFoundPage';
import { resolveRoute } from './routes';

export default function Root({ path }: { path?: string }) {
  const route = resolveRoute(path ?? window.location.pathname);

  let page;
  switch (route.id) {
    case 'home':
      page = <App />;
      break;
    case 'privacy':
    case 'disclaimer':
      page = <LegalPage kind={route.id} />;
      break;
    default:
      page = <NotFoundPage />;
  }

  return (
    <>
      {page}
      <Analytics />
    </>
  );
}
